import Model from "~~/package/mapper/Model";
import { createModel } from "~~/package/utils/ModelUtil";
import { ProSkillManagerType } from "~~/package/mapper/proSkillManager/model/ProSkillManagerType";

export class ProSkillAssureAssessmentCreationModel extends Model {
  constructor(
    public customAssessmentId: number = 0,
    public type: ProSkillManagerType = ProSkillManagerType.INTERNAL,
    public title: string = "",
    public description: string = "",
    public eyeTrackingFlag: boolean = false,
    public tabProctoringFlag: boolean = false,
    public shortcutFlag: boolean = false,
    public multiMonitorFlag: boolean = false,
    public copyPasteFlag: boolean = false,
    public screenRecordingFlag: boolean = false,
    public useExternalMonitoringFlag: boolean = false,
    public startedAt: string = "",
    public endedAt: string = "",
    public status: number = 0,
    public duration: number = -1,
    public testTemplateDtos: TestTemplateDTO[] = [],
    public timeZoneId: string = "",
    public reportLangs: string[] = []
  ) {
    super();
  }

  public static create(model: Partial<ProSkillAssureAssessmentCreationModel>): ProSkillAssureAssessmentCreationModel {
    return createModel<ProSkillAssureAssessmentCreationModel>(ProSkillAssureAssessmentCreationModel, {
      ...model
    });
  }

  public static checkNotNullData(model: ProSkillAssureAssessmentCreationModel): string[] {
    const errorMessages = [];
    if (!model.title) errorMessages.push("title");
    if (!model.type) errorMessages.push("type");
    if (!model.startedAt) errorMessages.push("startedAt");
    if (!model.endedAt) errorMessages.push("endDate");
    if (!model.duration || model.duration < 0) errorMessages.push("duration");
    if (!model.reportLangs || model.reportLangs.length === 0) errorMessages.push("reportLangs");
    return errorMessages;
  }

  public static checkValidDates(model: ProSkillAssureAssessmentCreationModel): string[] {
    const errorMessages = [];
    if (!this.isValidDateFormat(model.startedAt.split("T")[0])) errorMessages.push("invalid-startDate");
    if (!this.isValidDateFormat(model.endedAt.split("T")[0])) errorMessages.push("invalid-endDate");
    if (!this.isValidPeriod(model)) errorMessages.push("invalid-both");
    return errorMessages;
  }

  public static isValidDateFormat = (date: string): boolean => {
    if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(date)) {
      return false;
    }
    const [year, month, day] = date.split('-').map(Number);
    const daysInMonth = {
      1: 31, 2: (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28, // 윤년 고려
      3: 31, 4: 30, 5: 31, 6: 30,
      7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31
    } as const;

    const maxDays = daysInMonth[month as keyof typeof daysInMonth];
    return day <= maxDays;
  };

  public static isValidPeriod(model: ProSkillAssureAssessmentCreationModel): boolean {
    if (model.startedAt === "" || model.endedAt === "") return false;
    return new Date(model.startedAt).getTime() < new Date(model.endedAt).getTime();
  }
}

export class TestTemplateDTO {
  constructor(
    public testTemplateId: number | null = null,
    public referenceUrlExposureFlag: boolean = false,
) {}
}
